import { render, staticRenderFns } from "./JournalInsightBar.vue?vue&type=template&id=52301db1&scoped=true"
import script from "./JournalInsightBar.vue?vue&type=script&lang=js"
export * from "./JournalInsightBar.vue?vue&type=script&lang=js"
import style0 from "./JournalInsightBar.vue?vue&type=style&index=0&id=52301db1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52301db1",
  null
  
)

export default component.exports